import { CheckItem, Container, LandingButton, SectionHeading, SIGN_UP_PATH } from "./primitives";

const POINTS = [
  "Upload records from any hospital or format",
  "See medications, diagnoses, and labs in one view",
  "Understand your health in plain language, not medical jargon",
];

const OVERVIEW_ROWS = [
  { label: "Medications", tag: "5 active"      },
  { label: "Diagnoses",   tag: "2 conditions"  },
  { label: "Lab Results", tag: "Latest: Apr 8" },
];

function OverviewCard() {
  return (
    <div className="w-full max-w-[420px] rounded-2xl border border-[#E8E9EE] bg-[#F3F4F8] p-[18px]">
      <p className="text-[11px] font-bold text-[#120240]">My Health Overview</p>
      <div className="mt-3.5 space-y-2">
        {OVERVIEW_ROWS.map(row => (
          <div key={row.label} className="flex h-[42px] items-center justify-between rounded-lg bg-white px-3">
            <span className="text-[13px] font-semibold text-[#120240]">{row.label}</span>
            <span className="flex h-5 items-center rounded-md bg-[#F18095] px-2 text-[11px] font-bold text-white">{row.tag}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AudienceSection() {
  return (
    <section className="bg-white pt-[88px] pb-20 lg:pt-[110px] lg:pb-[100px]">
      <Container>
        <SectionHeading eyebrow="Built for you" title="Who is MedSyncIQ for?" />

        <div className="mt-14 grid items-center gap-12 lg:grid-cols-[600px_1fr] lg:gap-8">
          <div>
            <h3 className="max-w-[540px] text-[28px] font-extrabold leading-[1.2] tracking-[-0.03em] text-[#120240] md:text-[34px] md:leading-[42px]">
              Your full health history, finally in one place
            </h3>
            <ul className="!mt-[18px] space-y-3.5 text-[16px] text-[#374151]">
              {POINTS.map(p => <CheckItem key={p}>{p}</CheckItem>)}
            </ul>
            <LandingButton to={SIGN_UP_PATH} arrow className="!mt-8 !h-[43px] !px-6 !text-[14px]">
              Get Started Free
            </LandingButton>
          </div>
          <div className="flex justify-center lg:justify-start">
            <OverviewCard />
          </div>
        </div>
      </Container>
    </section>
  );
}
